<nz-tabset nzTabPosition="bottom" nzType="line" nzSize="large" style="height: 100%">
  <nz-tab [nzTitle]="uploadAFileTitle" *ngIf="allowUploadFile">
    <app-file-upload [isImage]="this.isImage" (fileUploaded)="this.fileUploaded.emit($event);"></app-file-upload>
  </nz-tab>
  <nz-tab [nzTitle]="takeAPictureTitle" *ngIf="allowUsingCamera" (nzDeselect)="cameraActive = false" (nzSelect)="cameraActive = true">
    <app-camera *ngIf="cameraActive" (fileUploaded)="this.fileUploaded.emit($event);"></app-camera>
  </nz-tab>
  <nz-tab [nzTitle]="signTitle" *ngIf="allowSignature" (nzDeselect)="signatureActive = false" (nzSelect)="signatureActive = true">
    <app-signature-pad [saveToImage]="this.isImage" *ngIf="signatureActive" (fileUploaded)="this.fileUploaded.emit($event);"></app-signature-pad>
  </nz-tab>
</nz-tabset>

<ng-template #uploadAFileTitle>
  <i nz-icon nzType="upload" nzTheme="outline"></i>
  {{'Upload a file' | locale}}
</ng-template>

<ng-template #takeAPictureTitle>
  <i nz-icon nzType="camera" nzTheme="outline"></i>
  {{'Take a picture' | locale}}
</ng-template>

<ng-template #signTitle>
  <i nz-icon nzType="edit" nzTheme="outline"></i>
  {{'Signature' | locale}}
</ng-template>
